import styled from 'styled-components';

export const Icon = styled.span`
  float: left;
  margin-left: 15px;
`;

export const ItemsCount = styled.span`
  display: flex;
  background: white;
  justify-content: center;
  align-items: center;
  height: 25px;
  min-width: 25px;
  border-radius: 50%;

  color: #3bd2c1;
  font-family: Poppins;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px;
  background-color: white;
  color: black;
  overflow-y: auto;
  overflow-x: hidden;
  height: 100%;
  border-radius: 0 0 12px 12px;
`;

export const LoadingDiv = styled.div`
  padding-top: 20px;
  justify-content: center;
  height: 60px;
  width: 100%;
  text-align: center;
`;

export const StyleKanbanWarning = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
`;
